<template>
    <v-app id="login" class="primary">
        <v-content>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>

                    <!-- Card para autenticação do usuário -->
                    <v-flex xs12 sm8 md4 lg4>
                        <v-card class="elevation-1 pa-3">
                            <v-card-text>
                                <div class="layout column align-center">
                                    <img
                                        :src="logo"
                                        :alt="altLogo"
                                        width="240"
                                    />
                                </div>
                                <br />
                                <br />
                                <v-form>
                                    <v-text-field
                                        append-icon="person"
                                        name="email"
                                        label="Email"
                                        type="text"
                                        v-model="user.email"
                                    ></v-text-field>
                                    <v-text-field
                                        append-icon="lock"
                                        name="senha"
                                        label="Senha"
                                        id="senha"
                                        type="password"
                                        v-model="user.senha"
                                        @keyup.enter.native="login"
                                    ></v-text-field>
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn block color="primary" @click="login" :loading="loading">Entrar</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
import { userKey, loginLogo, altLogo } from '@/global';

export default {
    data: () => ({
        loading: false,
        user   : {
            email: null,
            senha: null
        }
    }),
    computed   : {
        logo () {
            return loginLogo;
        },
        altLogo () {
            return altLogo;
        },
        sideToolbarColor () {
            return this.$vuetify.options.extra.sideNav;
        }
    },
    methods    : {
        login () {
            this.loading = true;
            this.$axios.post('usuarios/authenticate', this.user).then(res => {
                // console.log('"usuarios/authenticate" response:', res);
                this.$store.commit('setUser', res.data);
                localStorage.setItem(userKey, JSON.stringify(res.data));
                window.getApp.$emit('APP_LOGIN_SUCCESS');
            }).catch(e => {
                window.getApp.$emit('APP_LOGIN_FAILED');
            }).finally(() => {
                this.loading = false;
            })
        }
    }

};
</script>
<style scoped lang="css">
    #login {
        height  : 50%;
        width   : 100%;
        position: absolute;
        top     : 0;
        left    : 0;
        content : '';
        z-index : 0;
    }
</style>
